// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiPlaylistRemove } from "@mdi/js";

import { useDeleteShapefileList } from "../../../../../shapefiles/hooks/delete-shapefile-list/useDeleteShapefileList";
import { ACTION_TEXT } from "../constants/actionText.constants";
import { ShapefileAction } from "../nodes/StyledNodePartials";

interface ClearSelectedItemsActionProps {
  onContextMenuClose?: () => void;
}

export function ClearSelectedItemsAction({
  onContextMenuClose
}: ClearSelectedItemsActionProps) {
  const deleteShapefileModal = useDeleteShapefileList();

  if (!deleteShapefileModal.manageLayerTree.isManageMode) {
    return null;
  }

  const handleClearSelection = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    evt.preventDefault();

    deleteShapefileModal.manageLayerTree.handleOnCheck([]);

    if (onContextMenuClose) {
      onContextMenuClose();
    }
  };

  return (
    <ShapefileAction
      onClick={handleClearSelection}
      disabled={deleteShapefileModal.manageLayerTree.checkedKeys.length === 0}>
      <Icon path={mdiPlaylistRemove} size={"18px"} />
      {ACTION_TEXT.CLEAR_SELECTED_ITEMS}
    </ShapefileAction>
  );
}
